import { Box, makeStyles, TextField } from '@material-ui/core';
import React, { FC, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { editBgImage } from 'src/store/modules/imageUpload';
import { RootState, useSelector } from 'src/store';
import AboutImageTooltip from 'src/components/AboutIamgeTooltip';

interface editBgImageProps {
  menuTitle: string;
  type: string;
}

const EditBgImage: FC<editBgImageProps> = ({ menuTitle, type }) => {
  return (
    <div
      style={{
        padding: '1.5rem 1rem'
      }}
    >
      <div
        style={{
          marginBottom: '1.5rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {menuTitle}
        <AboutImageTooltip />
      </div>
      <Box style={{ padding: '0.5rem', border: '1px solid #d9d9d9' }}>
        <BgImage type={type} />
      </Box>
    </div>
  );
};

export default EditBgImage;

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    height: '100px',
    outline: 'none',
    overflow: 'overlay',
    '&:focus': {
      border: 0,
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  }
}));
export const BgImage = ({ type }: any) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(bgImage?.[type]);
  }, [bgImage, switchImageType]);

  const handleChange = e => {
    const textSplit = e.target.value.split('');
    if (
      textSplit[textSplit.length - 1] === '\\' ||
      textSplit[textSplit.length - 1] === '\n'
    )
      return;
    setUrl(e.target.value);
    const newImage = e.target.value;
    const newBgImage = { [type]: newImage };
    dispatch(editBgImage({ ...bgImage, ...newBgImage }));
  };
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100px',
          padding: 0,
          cursor: 'pointer',
          display: 'flex',
          gap: '0.5rem',
          color: '#000',
          fontFamily: 'Roboto',
          fontSize: '0.75rem',
          fontWeight: 400
        }}
      >
        <TextField
          inputRef={inputRef}
          id="imageInput"
          multiline
          value={url}
          onChange={handleChange}
          placeholder="Please embed image URL"
          className={classes.input}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputText
            },
            disableUnderline: true
          }}
        />
      </div>
    </Box>
  );
};
